import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SecondAndMinute from './cron/secondAndMinute';
import hour from './cron/hour';
import day from './cron/day';
import month from './cron/month';
import week from './cron/week';
import year from './cron/year';
export default {
  props: {
    value: {
      type: String
    }
  },
  data: function data() {
    return {
      //
      activeName: 's',
      sVal: '',
      mVal: '',
      hVal: '',
      dVal: '',
      monthVal: '',
      weekVal: '',
      yearVal: ''
    };
  },
  watch: {
    'value': function value(a, b) {
      this.updateVal();
    }
  },
  computed: {
    tableData: function tableData() {
      return [{
        sVal: this.sVal,
        mVal: this.mVal,
        hVal: this.hVal,
        dVal: this.dVal,
        monthVal: this.monthVal,
        weekVal: this.weekVal,
        yearVal: this.yearVal
      }];
    },
    value_: function value_() {
      if (!this.dVal && !this.weekVal) {
        return '';
      }

      if (this.dVal === '?' && this.weekVal === '?') {
        this.$message.error('日期与星期不可以同时为“不指定”');
      }

      if (this.dVal !== '?' && this.weekVal !== '?') {
        this.$message.error('日期与星期必须有一个为“不指定”');
      }

      var v = "".concat(this.sVal, " ").concat(this.mVal, " ").concat(this.hVal, " ").concat(this.dVal, " ").concat(this.monthVal, " ").concat(this.weekVal, " ").concat(this.yearVal);

      if (v !== this.value) {
        this.$emit('input', v);
      }

      return v;
    }
  },
  methods: {
    updateVal: function updateVal() {
      if (!this.value) {
        return;
      }

      var arrays = this.value.split(' ');
      this.sVal = arrays[0];
      this.mVal = arrays[1];
      this.hVal = arrays[2];
      this.dVal = arrays[3];
      this.monthVal = arrays[4];
      this.weekVal = arrays[5];
      this.yearVal = arrays[6];
    }
  },
  created: function created() {
    this.updateVal();
  },
  components: {
    SecondAndMinute: SecondAndMinute,
    hour: hour,
    day: day,
    month: month,
    week: week,
    year: year
  }
};